import React, { Component } from 'react';
import classNames from 'classnames';
import { RichUtils } from 'draft-js';

export function InsertFormulaButton({ theme, store, onInsert }) {
	const disabled = !store || store.getEditorEnviorment() !== 'root'
		|| RichUtils.getCurrentBlockType(store.getEditorState()) === 'code-block';
	return (
		<div className={theme.buttonWrapper}>
			<button className={theme.button} onClick={disabled ? null : onInsert}>
				<i className="qa-ico-sigma" title="插入公式 (输入 $ 快速插入)">Σ</i>
			</button>
		</div>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/formulaPlugin/components/InsertFormulaButton.jsx